import { useEffect, useRef, useState } from "react";
import ReaderDashboardJoinSession from "./ReaderDashboardJoinSession";
import { useMeetingStore } from "../../../store/meeting.store";
import { toast } from "react-hot-toast";
import SearchSessions from "../SearchSessions";
import api from "../../../lib/api";
import { useAuth } from "../../../context/AuthProvider";
import { socket } from "../../../components/mediasoup/socket";
import RCJMeeting from "../../../components/mediasoup-ui/RCJ.Meeting";
import logger from "../../../utils/logger";

const ReaderDashboard = () => {
  const { user } = useAuth();

  const readerCauseIconShow = useMeetingStore((s) => s.readerCauseIconShow);
  const meetingStarted = useMeetingStore((s) => s.meetingStarted);
  const setMeetingStarted = useMeetingStore((s) => s.setMeetingStarted);
  const setCauses = useMeetingStore((s) => s.setCauses);
  // const { data } = useSWR(`/api/reader/cases`);
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    if (user?.role !== "Reader") {
      setData(null);
      return;
    }
    const fetchData = async () => {
      try {
        const response = await api.get("/api/reader/cases");
        const result = await response?.data;
        // logger.log("reader cases", result);
        setCauses(result.data);
        setData(result);
      } catch (error) {
        logger.error("Error fetching reader cases:", error);
      }
    };
    fetchData();
  }, [user]);
  const delegation = data?.delegation;

  useEffect(() => {
    if (user?.role !== "Reader") return;
    if (!socket) return;
    if (delegation) {
      useMeetingStore.getState().setReaderCauseIconShow(true);
    }

    const onDelegationUpdated = (socketData: any) => {
      if (user?.role !== "Reader") return;
      if (data?.courtRoomData?.courtRoomId !== socketData?.courtRoomId) return;
      if (socketData.enabled) {
        toast.success("Delegation Enabled", { id: "delegation-enabled" });
      } else {
        toast("Delegation Disabled", { id: "delegation-disabled" });
        setMeetingStarted(false);
      }

      useMeetingStore.getState().setReaderCauseIconShow(socketData.enabled);
    };

    socket.on("reader-delegation-updated", onDelegationUpdated);

    return () => {
      socket.off("reader-delegation-updated", onDelegationUpdated);
    };
  }, [user?.role, socket, delegation, data, setMeetingStarted]);

  useEffect(() => {
    if (!socket) return;

    const onEndMeeting = (socketData: any) => {
      if (user?.role !== "Reader") return;
      if (socketData.roomNo === data?.courtRoomData?.courtRoomId) {
        setMeetingStarted(false);
      }
    };

    socket.on("end-meeting", onEndMeeting);

    return () => {
      socket.off("end-meeting", onEndMeeting);
    };
  }, [socket, user?.role, data, setMeetingStarted]);

  const elementRef = useRef<HTMLDivElement>(null);

  const requestFullscreen = () => {
    const el = elementRef.current;
    if (!el) return;

    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if ((el as any).webkitRequestFullscreen) {
      (el as any).webkitRequestFullscreen(); // Safari
    } else if ((el as any).msRequestFullscreen) {
      (el as any).msRequestFullscreen(); // IE11
    }
  };
  useEffect(() => {
    if (meetingStarted && import.meta.env.VITE_APP_ENV === "production") {
      requestFullscreen();
    }
  }, [meetingStarted]);

  return (
    <div>
      {meetingStarted && (
        <div ref={elementRef} className="court-fullscreen">
          <RCJMeeting />
        </div>
      )}
      {readerCauseIconShow && !meetingStarted && (
        <ReaderDashboardJoinSession data={data} />
      )}
      {!readerCauseIconShow && !meetingStarted && <SearchSessions />}
    </div>
  );
};

export default ReaderDashboard;
